import type { IntlShape } from 'react-intl'
import type { DiscountGroupHeader } from './types'

export const discountGroupHeaders: DiscountGroupHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Koodi',
				description: 'Table column header: Code',
			}),
		key: 'code',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Määräajat',
				description: 'Table column header: Deadlines',
			}),
		key: 'deadlines', //TODO: RENDER MULTIPLE COLUMNS, JUST LIKE IN THE SCREENSHOTS
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kuvaus',
				description: 'Table column header: Description',
			}),
		key: 'description',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
]

export const tableHeaders: DiscountGroupHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuoteryhmä',
				description: 'Table column header: Product Group',
			}),
		key: 'productGroup',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuote',
				description: 'Table column header: Product',
			}),
		key: 'product',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
]
